import styled from "styled-components";

export const StyledNewHome = styled.div<{ mainColor: string }>`
    width: 100%;
    /* position: relative;
    top: -65px; */
    /* top: -85px;
    @media (max-width: ${(p) => p.theme.breakPoints.breakMobile}) {
        top: -50px;
    } */

    position: absolute;
    top: 112px;
    .background {
        width: 100%;
        height: 50px;
        position: absolute;
        top: 112px;
        // background: linear-gradient(to bottom, #ffffff, transparent);
    }
    .ant-tabs-ink-bar {
        background-color: ${(p) => p.mainColor};
        height: 3px !important;
        border-radius: 5px;
        width: 30px !important;
        left: 9% !important;
    }
    .preview {
        width: calc(100% - 30px);
        position: relative;
        background-color: #fff;
        /* background-image: url("/images/logoAuth.png"); */
        background-repeat: no-repeat;
        background-position: 12px 12px;
        margin: 0 auto;
        /* box-shadow: rgb(231 230 220) 1px 5px 14px 3px; */
        /* box-shadow: rgb(196 196 196 / 40%) 0px 0px 11px 2px; */
        box-shadow: 0px 0px 8px rgba(175, 175, 175, 0.16);
        padding: 16px;
        border-radius: 8px;
        .avatar-layout {
            display: flex;
            flex-direction: row-reverse;
        }
        .ant-avatar {
            cursor: pointer;
        }
        .circle-avatar-user-layout {
            margin-top: -51px;
        }
        .circle-avatar-user {
            cursor: pointer;
            img {
                border-radius: 50%;
            }
        }
        .profile-info {
            display: flex;
            justify-content: space-between;
            align-items: center;
            /* margin-top: 10px; */
            .avatar_name {
                font-weight: 500;
                font-size: 20px;
                text-align: center;
                color: black;
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                .name {
                    font-size: 20px;
                    line-height: 27px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    /* display: -webkit-box; */
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    word-break: break-word;
                    overflow: hidden;
                    max-width: 260px;
                    white-space: nowrap;
                    @media (max-width: ${(p) => p.theme.breakPoints.breakMobileMax}) {
                        max-width: 180px;
                    }
                    @media (max-width: ${(p) => p.theme.breakPoints.breakMobileLarge}) {
                        max-width: 150px;
                    }
                    @media (max-width: ${(p) => p.theme.breakPoints.breakMobile}) {
                        max-width: 100px;
                    }
                }
                .hello {
                    font-weight: 300;
                }
            }
            .user-actions {
                display: flex;
                align-items: center;
                justify-content: space-between;
                .star {
                    cursor: pointer;
                    margin-right: 10px;
                }
                .rank-layout {
                }
            }
        }
        .good {
            text-align: center;
            color: #fff;
            font-weight: 500;
            font-size: 8px;
            line-height: 11px;
            padding: 4px 8px;
            background: #816b00;
            display: inline-block;
            border-radius: 12px;
            position: relative;
            margin-top: 12px;
            top: -8px;
            span {
                display: inline-block;
                margin: 0 4px;
                font-size: 11px;
            }
        }
        .user-progress {
            margin-bottom: 2px;
            .progress-info {
                display: flex;
                justify-content: space-between;
                &:first-child {
                    color: #919191;
                }

                p.label {
                    margin-top: 0.5em;
                    /* font-size: 11px; */
                    color: #919191;
                }
                p.text {
                    margin-top: 0.5em;
                    /* font-size: 11px; */
                    color: black;
                }
            }
        }
        .star_coupans {
            display: flex;
            align-items: center;
            flex-flow: row;
            margin-bottom: 12px;
            .point {
                color: ${(p) => p.mainColor};
                display: initial !important;
                /* font-weight: 500; */
            }
            .coupon {
                /* font-size: 16px; */
                color: black;
                display: initial !important;
            }
            .star_point {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                min-width: 27%;
                margin-right: 10px;
                box-shadow: 0px 3px 6px rgba(143, 143, 143, 0.16);
                padding: 3%;
                span {
                    /* font-weight: 400; */
                    display: block;
                    cursor: pointer;
                    margin-top: 3px;
                }
                .point {
                    /* font-size: 16px; */
                    /* font-weight: 500; */
                }
                .coupon {
                    /* font-weight: 400; */
                }
            }
            .line {
                height: 40px;
                width: 1px;
                background-color: #707070;
                opacity: 0.5;
            }
            .desc {
                font-weight: normal;
                font-size: 10px;
                line-height: 13px;
                color: #989898;
                position: relative;
                left: 2px;
                font-weight: 500 !important;
                cursor: pointer;
            }
        }
        .desc_end {
            font-weight: normal;
            font-size: 8px;
            line-height: 11px;

            width: 50%;
            text-align: center;
            color: #989898;
        }
    }
    .features {
        width: calc(100% - 30px);
        margin: 0 auto;
        margin-top: 16px;
        .card {
            padding: 12px 16px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            background: #fff;
            box-shadow: 0px 0px 8px rgb(175 175 175 / 16%);
            .title {
                display: flex;
                align-items: center;
                p {
                    margin: 0;
                    font-size: 12px;
                    line-height: 16px;
                    font-weight: 500;
                    color: #000;
                }
            }
        }
    }
    .nav-bar {
        padding: 3px 16px;
        background-color: transparent;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
        margin-top: 4px;
        .item {
            /* width: 25%; */
            text-align: center;
            padding: 15px 0;
            /* font-weight: normal; */
            /* font-size: 14px; */
            line-height: 21px;
            color: #989898;
            cursor: pointer;
            position: relative;

            font-style: normal;
        }
        .under {
            color: #000000;
            font-size: 16px;
            /* font-weight: 400; */
            &::after {
                content: "";
                position: absolute;
                bottom: 0px;
                left: 45%;
                width: 56%;
                height: 3px;
                background-color: ${(p) => p.mainColor};
                transform: translateX(-50%);
            }
        }
    }
    .preview {
        width: calc(100%);
        position: relative;
        background-color: #fff;
        /* background-image: url("/images/logoAuth.png"); */
        background-repeat: no-repeat;
        background-position: 12px 12px;
        margin: 0 auto;
        /* box-shadow: rgb(231 230 220) 1px 5px 14px 3px; */
        box-shadow: rgb(196 196 196 / 25%) 0px 0px 11px 2px;
        padding: 16px 22px;
        border-radius: 8px;
    }
    .ant-tabs .ant-tabs-left-bar .ant-tabs-tab {
        text-align: center;
        color: #919191;
    }
    .ant-tabs .ant-tabs-left-bar,
    .ant-tabs .ant-tabs-left-content {
        border: none;
    }
    .ant-tabs-nav .ant-tabs-tab-active {
        background: #fff;
        color: #000 !important;
    }
    .ant-tabs-ink-bar {
        background-color: #000;
    }
    .ant-tabs .ant-tabs-left-content {
        height: 100%;
        background: #fff;
    }
    .ant-tabs {
        width: 100%;
    }
    .ant-tabs .ant-tabs-left-bar .ant-tabs-ink-bar {
        left: 0;
        right: auto;
    }
    .SalonName {
        display: flex;
        flex-direction: column;
    }
    .fixBorderRadius {
        border-radius: 0;
    }
    .topSalonName h1 {
        font-size: 18px;
        color: #000;
        font-weight: 500;
        cursor: pointer;
    }
    #phone {
        cursor: pointer;
    }
    .topStoreInfo {
        display: flex;
    }
    .topSalonName h1 svg {
        margin-left: 10px;
    }
    .topSalonName {
        display: flex;
        place-content: space-between;
    }
    .topStoreInfo svg {
        margin-left: 10px;
    }
    .botSalonName p {
        font-size: 14px;
        color: #919191;
        margin-bottom: 0;
    }
    .popularSection {
        padding: 16px 22px;
        background: #fafafa;
    }
    .secondH1 {
        font-weight: 500;
        font-size: 15px;
        color: #000;
    }
    .swiper-slide {
        box-shadow: rgb(196 196 196 / 25%) 0px 0px 11px 2px;
        border-radius: 8px;
        display: flex;
        flex-direction: column;
        cursor: pointer;
        img {
            height: 170px;
            border-radius: 4px;
        }
    }
    .ServiceTitle {
        width: 100%;
        padding: 0 10px;
        text-align: left;
        margin-top: 10px;
    }
    .topServiceTitle {
        font-size: 15px;
        color: #000;
    }
    .priceAndArrow h2 {
        font-size: 16px;
        color: #f22f46;
        font-weight: 500;
        margin: 0;
    }
    .priceAndArrow {
        display: flex;
        place-content: space-between;
        width: 100%;
        padding: 0 10px;
        margin-bottom: 10px;
        place-items: center;
    }
    .swiperSection {
        width: 100%;
        padding-left: 12px;
        background: #fafafa;
    }
    .servicesSection {
        padding: 16px 0 0 0;
        display: flex;
    }
    .leftSide {
        display: flex;
        background: #f8f8f8;
        width: 105px;
        place-content: space-between;
    }
    .leftSide .nav-bar {
        padding: 0;
    }
    .nav-link {
        padding: 0;
        color: #000;
        border: none;
        background-color: #f8f8f8;
    }
    .leftSide .nav.nav-tabs {
        display: flex;
        flex-direction: column;
        width: 100%;
        padding: 0;
    }
    .rightSide {
        width: 100%;
        padding-bottom: 20px;
        background: #fff;
    }
    .nav-link.active {
        border: none;
        color: #000;
        background-color: #fff;
    }
    .leftSide .nav-item {
        border: none;
        color: #000;
        background-color: #f8f8f8;
        padding-right: 20px;
    }
    .nav-tabs {
        border: none;
    }
    .imageBannerSection img {
        width: 100%;
    }
    .swiper-wrapper {
        padding-bottom: 10px;
        padding-left: 10px;
    }
    .coverImage img {
        border-radius: 8px;
        width: 80px;
        height: 80px;
    }
    .allServices {
        margin-top: 20px;
        display: flex;
    }
    .serviceInfo h1 {
        font-size: 16px;
        margin-bottom: 0.3rem;
    }
    .serviceInfo p {
        font-size: 10px;
        color: #919191;
        margin-bottom: 1.4rem;
    }
    .serviceInfo {
        margin-left: 20px;
        width: 100%;
        position: relative;
    }
    .serviceInfo .priceAndArrow {
        margin-left: 0;
        padding-left: 0;
        margin-bottom: 0;
        position: absolute;
        bottom: 5px;
        padding-right: 25px;
    }
    .topNav .nav-link {
        text-align: center;
        padding: 15px 0;
        font-weight: normal;
        font-size: 15px;
        line-height: 21px;
        color: #989898;
        background: transparent;
        cursor: pointer;
        position: relative;
        font-style: normal;
    }
    .topNav li {
        padding: 0 !important;
    }
    .topNav .nav-link.active {
        color: #000000;
        font-weight: 600;
        &::after {
            content: "";
            position: absolute;
            bottom: 8px;
            left: 45%;
            width: 50%;
            height: 2.5px;
            border-radius: 10px;
            background-color: #f22f46;
            -webkit-transform: translateX(-50%);
            -ms-transform: translateX(-50%);
            transform: translateX(-50%);
        }
    }
    .leftNavs .nav-item {
        padding: 5px 0;
        display: flex;
        place-content: center;
        height: 70px;
        a {
            place-content: center;
            text-align: center;
        }
    }
    .leftNavs .nav-link {
        display: flex;
        flex-direction: column;
        place-items: center;
        padding: 10px 0;
    }
    .leftNavs .nav-link svg {
        margin-bottom: 10px;
    }
    .leftNavs .nav-link.active {
        width: 100%;
        display: flex;
        align-items: center;
    }
    .leftSide .nav-link.active {
        &::after {
            content: "";
            position: absolute;
            left: 1.5px;
            width: 3px;
            height: 70px;
            border-radius: 8px;
            background-color: #000;
            -webkit-transform: translateX(-50%);
            -ms-transform: translateX(-50%);
            transform: translateX(-50%);
        }
    }
    .noTopPadding {
        padding-top: 0 !important;
    }

    // Staff Section
    .staffSection {
        padding: 0 20px;
    }
    .staffSection .coverImage img {
        width: 85px;
    }
    .staffSection .serviceInfo p {
        margin-bottom: 0;
        display: flex;
    }
    .staffSection .serviceInfo p span {
        margin-left: 5px;
    }
    .staffSection .serviceInfo {
        padding: 8px 0;
    }
    .staffSection .serviceInfo h1 {
        margin-bottom: 0.4rem;
    }
    .staffButton {
        background: #fff;
        border-radius: 20px;
        border: 1px solid #f22f46;
        color: #f22f46;
        width: 65px;
        cursor: pointer;
    }

    .nav-bar {
        padding: 3px 22px;
        background-color: transparent;
        display: flex;
        flex-wrap: wrap;
        // margin-top: 10px;
        justify-content: flex-start;
        .item {
            /* width: 25%; */
            text-align: center;
            padding: 15px 0;
            font-weight: normal;
            font-size: 15px;
            line-height: 21px;
            color: #989898;
            background: transparent;
            cursor: pointer;
            position: relative;
            margin-right: 25px;
            font-style: normal;
        }
        .under {
            color: #000000;
            font-weight: 600;
            &::after {
                content: "";
                position: absolute;
                bottom: 8px;
                left: 45%;
                width: 50%;
                height: 2px;
                background-color: #f22f46;
                transform: translateX(-50%);
            }
        }
    }
    // Walkin Codes
    .threeTab .tab {
        background: #fff;
        border-radius: 3px;
        padding: 18px 20px;
        display: flex;
        place-content: space-between;
        place-items: center;
        cursor: pointer;
        margin-bottom: 20px;
    }
    .threeTab .tab h2 {
        font-size: 16px;
        margin-bottom: 0;
    }
    .threeTab .arrowIcon {
        font-weight: 500;
        font-size: 18px;
    }
    .threeTab .btn {
        background: #fff;
    }
    .wholeGrayPage {
        background: #f7f7f8;
        padding: 20px;
    }
    // Walkin Codes
    // Shop Choosing
    .shopDiv {
        cursor: pointer;
    }
    .shopDiv .leftShopDetail {
        width: 65%;
    }
    .shopDiv .leftShopDetail h3 {
        font-size: 14px;
    }
    .shopDiv .leftShopDetail p {
        font-size: 12px;
    }
    .shopDiv .leftShopDetail .small {
        font-size: 12px;
        color: #a5a5a5;
    }
    .rightShopDetail {
        height: 100%;
        border-left: 1px solid #a5a5a5;
        display: flex;
        padding: 20px;
    }
    .rightShopDetail p {
        margin: 0;
    }
    // Shop Choosing
    // Store details
    .topStoreInfo2 {
        display: flex;
        width: 100%;
        place-items: center;
    }
    .circle {
        background: #f22f46;
        width: 60px;
        height: 60px;
        border-radius: 50%;
        margin-right: 20px;
        display: flex;
        place-content: center;
        place-items: center;
    }
    .wholePage {
        padding: 20px;
    }
    .topStoreInfo2 .circle h1 {
        font-size: 12px;
        color: #fff;
        text-align: center;
        margin: 0;
    }
    .rightOfLogoSide h1 {
        font-size: 16px;
    }
    .rightOfLogoSide h2 {
        font-size: 14px;
        color: #646464;
        margin: 0;
    }
    .pinRow {
        display: flex;
        place-content: space-between;
        margin-top: 3rem;
        margin-bottom: 3rem;
    }
    .pinSide {
        display: flex;
    }
    .pinSide svg {
        margin-right: 20px;
        margin-top: 2px;
    }
    .pinSide p {
        font-size: 14px;
        color: #646464;
    }
    .customHR {
        border-top: none;
        height: 10px;
        background: #f7f7f8;
    }
    .phoneRow {
        display: flex;
        place-content: space-between;
        place-items: center;
    }
    .leftPhoneRow {
        display: flex;
    }
    .phoneRow svg {
        margin-right: 20px;
    }
    .phoneRow p {
        font-size: 14px;
        color: #646464;
        margin: 0;
    }
    .openningRow {
        margin-top: 20px;
        display: flex;
        gap: 3rem;
    }
    .openningRow svg {
        margin-right: 20px;
    }
    .openningTime h1 {
        font-size: 14px;
    }
    .openningTime p {
        font-size: 14px;
        color: #646464;
    }
    .firstOpenning {
        display: flex;
    }
    // Store details
    .topServiceTitle {
        font-size: 16px;
        font-weight: 500;
        color: #000;
        line-height: 22px;
    }
    .drawerBody .description {
        color: #a5a5a5;
        font-size: 14px;
        font-weight: 500;
        line-height: 19px;
    }
`;

export const StyledContainerSHome = styled.div`
    /* min-height: 80vh; */
    background-color: transparent;
    .ant-empty {
        margin-top: 25px;
    }
`;
